export default {
  index: [
    {
      path: '/gwqytc',
      component: resolve => require(['./gw_qytcIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/gw_qytc/_router.js